const DropdownInput = ({
    label,
    value,
    options,
    name,
    state,
    validationRules,
    onChange,
    booleanValue,
    numberValue,
    useDefaultValue = true,
    defaultPlaceholder = "select option",
    innerRef,
    ...rest
}) => {
    if (state) {
        value = state[name];
    }

    const _onChange = (e) => {
        if (!booleanValue && !numberValue) {
            return onChange(e);
        }
        if (booleanValue) {
            const newEvent = {
                target: {
                    name: e.target.name,
                    value: e.target.value.toLowerCase() === "true",
                },
            };
            return onChange(newEvent);
        }
        if (numberValue) {
            const newEvent = {
                target: {
                    name: e.target.name,
                    value: +e.target.value,
                },
            };
            return onChange(newEvent);
        }
    };

    return (
        <div className={"form-input-area__input "}>
            <label>
                {label && <span> {label} </span>}
                <select
                    name={name}
                    value={value}
                    onChange={_onChange}
                    ref={innerRef}
                    style={{
                        maxWidth: "100%",
                        textOverflow: "ellipsis",
                        overflow: "hidden",
                    }}
                    {...rest}
                >
                    {
                        !useDefaultValue && (
                            <option value={null}>{defaultPlaceholder}</option>
                        ) // TODO determine if null is okay here
                    }
                    {options.map((option, index) => {
                        return (
                            <option key={index} value={option.value}>
                                {option.label}
                            </option>
                        );
                    })}
                </select>
            </label>
        </div>
    );
};

export default DropdownInput;
